import { render, staticRenderFns } from "./trainingsPage.vue?vue&type=template&id=1cba7a48&scoped=true"
import script from "./trainingsPage.vue?vue&type=script&lang=ts"
export * from "./trainingsPage.vue?vue&type=script&lang=ts"
import style0 from "./trainingsPage.vue?vue&type=style&index=0&id=1cba7a48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cba7a48",
  null
  
)

export default component.exports